import React from 'react';
import { Redirect, Router } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import NotFound from './pages/NotFound';
import { history } from './helpers/history';
import NotAuthorizedLayout from './layout/NotAuthorizedLayout';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Registration from './pages/Registration';
import Detail from './pages/Detail';
import { ForgotPassword } from './pages/ForgotPassword';
import { Unauthorized } from './pages/Unauthorized';
import { useSelector } from 'react-redux';
import { ApplicationState } from './store';
import { AuthRoute } from './AuthRoute';
import Logout from './pages/Logout';

export const RoutePaths = {
  Login: '/login',
  Logout: '/logout',
  Unauthorized: '/unauthorized',
  Overview: '/',
  Registration: '/registration',
  Detail: '/detail/stack/:stackId',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
};

export const Routes: React.FC = (): JSX.Element => {
  const isLoggedIn = useSelector(
    (state: ApplicationState) => state.auth.token !== undefined,
  );

  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={RoutePaths.Login}
          render={() =>
            !isLoggedIn ? (
              <NotAuthorizedLayout>
                <Login />
              </NotAuthorizedLayout>
            ) : (
              <Redirect to={RoutePaths.Overview} />
            )
          }
        />
        <Route
          exact
          path={RoutePaths.Logout}
          render={() => (
            <NotAuthorizedLayout>
              <Logout />
            </NotAuthorizedLayout>
          )}
        />
        <Route
          exact
          path={RoutePaths.Unauthorized}
          render={() => (
            <NotAuthorizedLayout>
              <Unauthorized />
            </NotAuthorizedLayout>
          )}
        />
        <Route
          path={RoutePaths.ForgotPassword}
          render={() => (
            <NotAuthorizedLayout>
              <ForgotPassword />
            </NotAuthorizedLayout>
          )}
        />
        <AuthRoute exact path={RoutePaths.Overview} Component={Overview} />
        <AuthRoute path={RoutePaths.Registration} Component={Registration} />
        <AuthRoute exact path={RoutePaths.Detail} Component={Detail} />

        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
